export enum CometUserRoleTypeString {
  ACCEPTS_APPLICATIONS = 'acceptsApplications',
  BLOCK_USERS = 'blockUsers',
  CHAT_BOT_BETA = 'chatBotBeta',
  CHECKR_TAC = 'checkrTac',
  /**
   * @deprecated
   */
  CHECKR_TAC_LANDLORD = 'checkrTacLandlord',
  /**
   * @deprecated
   */
  CHECKR_TAC_RENTER = 'checkrTacRenter',
  CIC_CONFIRMATION_RENTER = 'cicConfirmationRenter',
  CIC_TAC = 'cicTac',
  COMET_APPLICATIONS_USER = 'cometApplicationsUser',
  COMET_FEATURES_USER = 'cometFeaturesUser',
  COMET_LEASES_USER = 'cometLeasesUser',
  COMET_MAINTENANCE_USER = 'cometMaintenanceUser',
  COMET_PAYMENTS_USER = 'cometPaymentsUser',
  DELETE_LISTING = 'deleteListing',
  ENTERPRISE_DOWNGRADED_EXPERIENCE = 'enterpriseDowngradedExperience',
  EXPERIAN_CIC_WRITTEN_CONSENT_RENTER = 'experianCicWrittenConsentRenter',
  EXPERIAN_PRIVACY_POLICY = 'experianPrivacyPolicy',
  EXPERIAN_TAC = 'experianTac',
  EXPERIAN_WRITTEN_CONSENT = 'experianWrittenConsent',
  EXPERIAN_WRITTEN_CONSENT_LANDLORD = 'experianWrittenConsentLandlord',
  EXPERIAN_WRITTEN_CONSENT_RENTER = 'experianWrittenConsentRenter',
  HOUSING_CONNECTOR = 'seattleHousingConnector',
  IMPERSONATE = 'impersonate',
  /**
   * @deprecated
   */
  LADMIN = 'ladmin',
  /**
   * @deprecated
   */
  LADMIN_ADMIN = 'ladminAdmin',
  /**
   * @deprecated
   */
  LADMIN_CONSUMER_CARE = 'ladminConsumerCare',
  /**
   * @deprecated
   */
  LADMIN_LAWYER = 'ladminLawyer',
  /**
   * @deprecated
   */
  LADMIN_SALES = 'ladminSales',
  /**
   * @deprecated
   */
  LDQ_MARKETING_USER = 'ldqMarketingUser',
  /**
   * @deprecated
   */
  LDQ_TIER_TWO_AND_THREE_USER = 'ldqTierTwoAndThreeUser',
  LEASING_BETA = 'leasingBeta',
  MANAGE_ROLES = 'manageRoles',
  /**
   * @deprecated
   */
  MARK_USERS_EMAIL_VERIFIED = 'markUsersEmailVerified',
  MULTIFAMILY_CUSTOMER = 'multifamilyCustomer',
  NON_ADVERTISER_CUSTOMER = 'nonAdvertiserCustomer',
  NUCLEUS_CUSTOMER = 'nucleusCustomer',
  /**
   * @deprecated
   */
  PAYMENTS_BETA = 'paymentsBeta',
  PLAID_TAC = 'plaidTac',
  POSTING_PATH_ADMIN = 'postingPathAdmin',
  PREMIUM_CUSTOMER = 'premiumCustomer',
  PROPERTY_MANAGER_ADD_PROPERTY = 'propertyManagerAddProperty',
  PROPERTY_MANAGER_ALL_PROPERTIES = 'propertyManagerAllProperties',
  PROPERTY_MANAGER_COMPANY_ADMIN = 'propertyManagerCompanyAdmin',
  PROPERTY_MANAGER_COMPANY_USER = 'propertyManagerCompanyUser',
  PROPERTY_MANAGER_PAY_INVOICE = 'propertyManagerPayInvoice',
  PROPERTY_MANAGER_RESPOND_TO_REVIEW = 'propertyManagerRespondToReview',
  PROPERTY_MANAGER_UPDATE_LISTING = 'propertyManagerUpdateListing',
  PROPERTY_MANAGER_VIEW_ANALYTICS = 'propertyManagerViewAnalytics',
  PROPERTY_MANAGER_VIEW_INVOICE = 'propertyManagerViewInvoice',
  PROPERTY_MANAGER_VIEW_MESSAGE = 'propertyManagerViewContact',
  ROCKET_SHIP_CUSTOMER = 'rocketShipCustomer',
  SELF_SERVE_CUSTOMER = 'selfServeCustomer',
  /**
   * @deprecated
   */
  SINGLE_FAMILY_ENTERPRISE_CUSTOMER_COMET_FEATURES_ALLOWED = 'rocketShipCustomerCometFeaturesAllowed',
  /**
   * @deprecated
   */
  SINGLE_FAMILY_ENTERPRISE_CUSTOMER_COMET_FEATURES_RESTRICTED = 'rocketShipCustomerCometFeaturesRestricted',
  /**
   * @deprecated
   */
  SINGLE_FAMILY_ENTERPRISE_CUSTOMER_GRANTED_ACCESS_COMET_FEATURES = 'rocketShipCustomerGrantedAccessCometFeatures',
  /**
   * @deprecated
   */
  SINGLE_FAMILY_ENTERPRISE_CUSTOMER_GRANTED_ADD_LISTING = 'rocketShipCustomerGrantedAddListing',
  /**
   * @deprecated
   */
  SINGLE_FAMILY_ENTERPRISE_CUSTOMER_ZRM_MANUAL_LISTING = 'rocketShipCustomerZrmManualListing',
  SINGLE_FAMILY_LEGACY = 'singleFamilyLegacyCustomer',
  SPOTLIGHT_CUSTOMER = 'spotlightCustomer',
  TERMS_ACCEPTED_STRIPE = 'termsAcceptedStripe',
  TERMS_ZILLOW_RENTAL_USER = 'termsAcceptedZillowRentalUser',
  ZILLOW_TAC = 'zillowTac',
}

export const CometUserRoleTypeString_values = [
  CometUserRoleTypeString.ACCEPTS_APPLICATIONS,
  CometUserRoleTypeString.BLOCK_USERS,
  CometUserRoleTypeString.CHAT_BOT_BETA,
  CometUserRoleTypeString.CHECKR_TAC,
  CometUserRoleTypeString.CHECKR_TAC_LANDLORD,
  CometUserRoleTypeString.CHECKR_TAC_RENTER,
  CometUserRoleTypeString.CIC_CONFIRMATION_RENTER,
  CometUserRoleTypeString.CIC_TAC,
  CometUserRoleTypeString.COMET_APPLICATIONS_USER,
  CometUserRoleTypeString.COMET_FEATURES_USER,
  CometUserRoleTypeString.COMET_LEASES_USER,
  CometUserRoleTypeString.COMET_MAINTENANCE_USER,
  CometUserRoleTypeString.COMET_PAYMENTS_USER,
  CometUserRoleTypeString.DELETE_LISTING,
  CometUserRoleTypeString.ENTERPRISE_DOWNGRADED_EXPERIENCE,
  CometUserRoleTypeString.EXPERIAN_CIC_WRITTEN_CONSENT_RENTER,
  CometUserRoleTypeString.EXPERIAN_PRIVACY_POLICY,
  CometUserRoleTypeString.EXPERIAN_TAC,
  CometUserRoleTypeString.EXPERIAN_WRITTEN_CONSENT,
  CometUserRoleTypeString.EXPERIAN_WRITTEN_CONSENT_LANDLORD,
  CometUserRoleTypeString.EXPERIAN_WRITTEN_CONSENT_RENTER,
  CometUserRoleTypeString.HOUSING_CONNECTOR,
  CometUserRoleTypeString.IMPERSONATE,
  CometUserRoleTypeString.LADMIN,
  CometUserRoleTypeString.LADMIN_ADMIN,
  CometUserRoleTypeString.LADMIN_CONSUMER_CARE,
  CometUserRoleTypeString.LADMIN_LAWYER,
  CometUserRoleTypeString.LADMIN_SALES,
  CometUserRoleTypeString.LDQ_MARKETING_USER,
  CometUserRoleTypeString.LDQ_TIER_TWO_AND_THREE_USER,
  CometUserRoleTypeString.LEASING_BETA,
  CometUserRoleTypeString.MANAGE_ROLES,
  CometUserRoleTypeString.MARK_USERS_EMAIL_VERIFIED,
  CometUserRoleTypeString.MULTIFAMILY_CUSTOMER,
  CometUserRoleTypeString.NON_ADVERTISER_CUSTOMER,
  CometUserRoleTypeString.NUCLEUS_CUSTOMER,
  CometUserRoleTypeString.PAYMENTS_BETA,
  CometUserRoleTypeString.PLAID_TAC,
  CometUserRoleTypeString.POSTING_PATH_ADMIN,
  CometUserRoleTypeString.PREMIUM_CUSTOMER,
  CometUserRoleTypeString.PROPERTY_MANAGER_ADD_PROPERTY,
  CometUserRoleTypeString.PROPERTY_MANAGER_ALL_PROPERTIES,
  CometUserRoleTypeString.PROPERTY_MANAGER_COMPANY_ADMIN,
  CometUserRoleTypeString.PROPERTY_MANAGER_COMPANY_USER,
  CometUserRoleTypeString.PROPERTY_MANAGER_PAY_INVOICE,
  CometUserRoleTypeString.PROPERTY_MANAGER_RESPOND_TO_REVIEW,
  CometUserRoleTypeString.PROPERTY_MANAGER_UPDATE_LISTING,
  CometUserRoleTypeString.PROPERTY_MANAGER_VIEW_ANALYTICS,
  CometUserRoleTypeString.PROPERTY_MANAGER_VIEW_INVOICE,
  CometUserRoleTypeString.PROPERTY_MANAGER_VIEW_MESSAGE,
  CometUserRoleTypeString.ROCKET_SHIP_CUSTOMER,
  CometUserRoleTypeString.SELF_SERVE_CUSTOMER,
  CometUserRoleTypeString.SINGLE_FAMILY_ENTERPRISE_CUSTOMER_COMET_FEATURES_ALLOWED,
  CometUserRoleTypeString.SINGLE_FAMILY_ENTERPRISE_CUSTOMER_COMET_FEATURES_RESTRICTED,
  CometUserRoleTypeString.SINGLE_FAMILY_ENTERPRISE_CUSTOMER_GRANTED_ACCESS_COMET_FEATURES,
  CometUserRoleTypeString.SINGLE_FAMILY_ENTERPRISE_CUSTOMER_GRANTED_ADD_LISTING,
  CometUserRoleTypeString.SINGLE_FAMILY_ENTERPRISE_CUSTOMER_ZRM_MANUAL_LISTING,
  CometUserRoleTypeString.SINGLE_FAMILY_LEGACY,
  CometUserRoleTypeString.SPOTLIGHT_CUSTOMER,
  CometUserRoleTypeString.TERMS_ACCEPTED_STRIPE,
  CometUserRoleTypeString.TERMS_ZILLOW_RENTAL_USER,
  CometUserRoleTypeString.ZILLOW_TAC,
] as const;
